import { END_POINTS } from "../constants/urls";
import { Users } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  status: number;
  data?: User;
  message: string;
};

type LoginResponseType = {
  status: number;
  data?: any;
  message: string;
};

type PostForgotPasswordResponse = {
  status: number;
  data?: User;
  message: string;
};

type PostResetPasswordResponse = {
  status: number;
  data?: any;
  message: string;
};

type PostChangePasswordResponse = {
  status: number;
  data?: any;
  message: string;
};

type GetProfileResponse = {
  status: number;
  code?: number;
  data?: any;
};

type CommonResponse = {
  status: number;
  message?: string;
  data?: any;
};

type GetUsersResponse = {
  approvedCount: number;
  count: number;
  pendingCount: number;
  rejectCount: number;
  user: Users[];
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postVerifyOtp: builder.mutation<LoginResponseType & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    postLogin: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    postForgotPassword: builder.mutation<PostForgotPasswordResponse, any>({
      query: (body) => ({
        url: `${END_POINTS.forgotPassword}`,
        method: "POST",
        body,
      }),
    }),
    postSetProfile: builder.mutation<CommonResponseType & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: "PATCH",
        body,
      }),
    }),
    postResetPassword: builder.mutation<PostResetPasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    postChangePassword: builder.mutation<PostChangePasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "POST",
        body,
      }),
    }),
    getProfile: builder.query<GetProfileResponse, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getProfile}/${id}`,
        method: "GET",
      }),
    }),

    logoutApi: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: "GET",
      }),
    }),
  }),
});

export const {
  usePostLoginMutation,
  usePostVerifyOtpMutation,
  usePostSetProfileMutation,
  usePostForgotPasswordMutation,
  usePostResetPasswordMutation,
  usePostChangePasswordMutation,
  useLazyGetProfileQuery,
  useLazyLogoutApiQuery,
} = authApi;
